import { organizationListQueryOptions } from "@/lib/queries/organization";
import { sessionQueryOptions } from "@/lib/queries/session";
import { needsRoleSelection } from "@/lib/utils/organization";
import { createFileRoute, isRedirect, redirect } from "@tanstack/react-router";

/**
 * Legacy route — redirects to /o/{slug}/select-role.
 * Kept for backwards compatibility with bookmarks/links.
 */
export const Route = createFileRoute("/(auth)/select-role")({
  beforeLoad: async ({ context }) => {
    let session;
    try {
      session = await context.queryClient.fetchQuery(sessionQueryOptions());
    } catch (error) {
      if (isRedirect(error)) throw error;
      throw redirect({ to: "/login" });
    }

    if (!session?.user || !session?.session) {
      throw redirect({ to: "/login" });
    }

    try {
      const organizations = await context.queryClient.fetchQuery({
        ...organizationListQueryOptions(),
        staleTime: 0,
      });

      if (organizations && organizations.length > 0) {
        const bareOrgs = organizations.filter((o) =>
          needsRoleSelection(o.metadata as string | null),
        );
        if (bareOrgs.length === 1) {
          throw redirect({
            to: "/o/$orgSlug/select-role",
            params: { orgSlug: bareOrgs[0].slug },
          });
        }
        // Zero or multiple bare orgs — redirect based on org count
        if (organizations.length === 1) {
          throw redirect({
            to: "/o/$orgSlug",
            params: { orgSlug: organizations[0].slug },
          });
        }
      }
    } catch (error) {
      if (isRedirect(error)) throw error;
    }

    throw redirect({ to: "/" });
  },
  // beforeLoad always throws a redirect — component never renders
  component: () => null,
});
